import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { FaSortDown } from 'react-icons/fa';
import isUndefined from 'lodash/isUndefined';
import { AuthContext } from 'context/AuthProvider';
import Select from 'components/UI/Antd/Select/Select';
import { VesselSelectWrapper } from './VesselSelect.style';

const VesselSelect = ({
  className = '',
  onlyHMRVessels,
  onSelectVessel = () => {},
  selectedParentVessel // if need to display the value from the component, not the global
}) => {
  const { t } = useTranslation();
  const { user, selectBoaterVessel, selectedBoaterVessel } =
    useContext(AuthContext);

  if (!user) {
    return null;
  }

  const { vessels } = user;

  let selections = [...vessels];
  if (onlyHMRVessels) {
    selections = vessels.filter(({ home_marina_id }) => home_marina_id);
  }
  const options = selections.map(({ id, name }) => ({
    label: name || t('VESSEL_NAME_UNNAMED'),
    value: id
  }));

  const handleChange = value => {
    selectBoaterVessel(value);
    onSelectVessel(value);
  };

  if (!options.length) {
    return null;
  }

  return (
    <VesselSelectWrapper className={className}>
      <Select
        style={{ width: 200 }}
        suffixIcon={<FaSortDown color='#545556' fontSize={20} />}
        disabled={options.length === 1}
        value={
          isUndefined(selectedParentVessel)
            ? selectedBoaterVessel
            : selectedParentVessel
        }
        options={options}
        onChange={handleChange}
      />
    </VesselSelectWrapper>
  );
};

export default VesselSelect;
